<template>
  <div>
    <b-table small striped hover
    @row-clicked="rowHouseClickHandler"
    :items="house"
    :fields="houseFields">
    </b-table>
    <b-row>
      <b-col>
        <b-button variant="success" style="float: right ;width: 100px" @click.stop="selectHouse">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button  variant="secondary" style="float: right ;width: 100px" @click.stop="hideFormHouse">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import moment from 'moment'

export default {
  props: {
    userInfo: null
  },
  data () {
    return {
      selectedHouse: null,
      house: [],
      houseFields: [
        {key: 'house_id', label: 'ID', sortable: true},
        {key: 'zonesIdString', label: this.$i18n.t('IP zone ID'), sortable: true},
        {key: 'connect_date', label: this.$i18n.t('Connected on'), sortable: true},
        {key: 'post_code', label: this.$i18n.t('Zip code'), sortable: true},
        {key: 'country', label: this.$i18n.t('Country'), sortable: true},
        {key: 'region', label: this.$i18n.t('Province/State'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true},
        {key: 'street', label: this.$i18n.t('Street'), sortable: true},
        {key: 'number', label: this.$i18n.t('Building#'), sortable: true},
        {key: 'building', label: this.$i18n.t('Constr.#'), sortable: true}
      ]
    }
  },
  methods: {
    selectHouse () {
      if (!this.selectedHouse) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select house'), 'Error')
      }
      this.$emit('input', this.selectedHouse.house_id)
      this.$emit('displayHouse')
      this.$emit('hideFormHouse')
    },
    hideFormHouse () {
      this.$emit('hideFormHouse')
    },
    rowHouseClickHandler (row) {
      if (this.selectedHouse) {
        this.selectedHouse._rowVariant = ''
      }
      this.selectedHouse = row
      this.$set(this.selectedHouse, '_rowVariant', 'info')
    },
    async load () {
      this.house = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_HOUSES).then(response => { return response.data })
      for (let i in this.house) {
        this.house[i].connect_date = moment(Number(this.house[i].connect_date) * 1000).format('MM-DD-YYYY')
        this.house[i].zonesIdString = ''
        for (let j in this.house[i].zones) {
          if (this.house[i].zonesIdString.length) {
            this.house[i].zonesIdString += ', '
          }
          this.house[i].zonesIdString += this.house[i].zones[j]
        }
      }
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/contacts/formHouse.vue